import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPopupCpny: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		let partScn = 'PT';
		if (searchParams.partNo !== undefined || searchParams.cpnyCd !== undefined) {
			queryStr = objectToQuerystring({
				partNo: searchParams.partNo,
				cpnyCd: searchParams.cpnyCd,
				causPartNo: searchParams.causPartNo,
				currentPage,
				pageUnit
			});
		}

		return (
			client
				//sfaas-onsite-fe
				.get(`${BASE_URL}/comm/commpopup/cpnyPopup/v1/cpnys/partScn/${partScn}` + queryStr)
				.then(response => (response && response.data) || null)
				.catch(error => {
					throw error.response.data;
				})
		);
	},
	calRpymAmt: param => {
		let queryStr = '';

		queryStr = objectToQuerystring({
			cmpnNo: param.cmpnNo /*캠페인번호*/,
			rtsh: param.rtsh /*적용변제율*/
		});

		return (
			client
				//.get(`${BASE_URL}/mqy/qlty/clamMst/v1/roNo/${param.roNo}/cpnyCd/${param.cpnyCd}/rtsh/${param.rtsh}`)
				.get(`${BASE_URL}/mqy/qlty/clamMst/v1/roNo/${param.roNo}/cpnyCd/${param.cpnyCd}/causPartNo/${param.causPartNo}` + queryStr)
				.then(response => (response && response.data) || null)
				.catch(error => {
					throw error;
				})
		);
	}
};
